import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "farmer" }
const _hoisted_2 = { class: "bg-image" }
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<p><span class=\"title desktop\">Please connect wallet to access staking</span></p><p style=\"margin-bottom:30px;\"><span class=\"title mobile\">Please connect </span></p><p style=\"margin-bottom:30px;\"><span class=\"title mobile\">wallet to</span></p><p><span class=\"title mobile\">access staking</span></p>", 4)
const _hoisted_8 = [
  _hoisted_4
]
const _hoisted_9 = {
  key: 0,
  class: "farmerAccArea"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { style: {"margin":"0 auto 25px auto"} }
const _hoisted_12 = { style: {"text-align":"center"} }
const _hoisted_13 = { class: "staked-counter desktop" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","margin-bottom":"30px"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "staked-counter mobile" }, "Residents at the ")
], -1)
const _hoisted_15 = { style: {"text-align":"center"} }
const _hoisted_16 = { class: "staked-counter mobile" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mb-10 setup-text" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mb-5 setup-text-subtitle" }, null, -1)
const _hoisted_20 = { class: "w-full text-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", null, "HOW TO STAKE", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " The \"Your Wallet\" area shows the residents you have that are available to be staked here. To stake, simply select the residents you wish to stake and when you've got all the residents shown in your vault, press the \"Move Residents\" button to send them to your vault’s wallet. Once your residents are in your vault, press \"Begin Staking\" to start earning $SHILLS. ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " The \"Your Vault\" panel shows the residents who are visiting Solana Hills Bank! The vault will be locked while residents are visiting the bank. To unlock the vault and get the residents back home, simply press the stop staking button, and click on the residents that will be leaving the bank. ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " To claim your $SHILLS, press the Refresh Account button to make sure the amount of $SHILLS is up to date, and simply press on the Claim button. ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " Any questions feel free to reach out to us on discord! ", -1)
const _hoisted_26 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ConfigPane),
      (!_ctx.wallet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    (!(!_ctx.wallet))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, "Residents at the bank: " + _toDisplayString(_ctx.farmAcc.gemsStaked - 1681) + "/3334", 1)
                  ]),
                  _hoisted_14,
                  _createElementVNode("p", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, " bank: " + _toDisplayString(_ctx.farmAcc.gemsStaked - 1681) + "/3334", 1)
                  ])
                ]),
                _createVNode(_component_FarmerDisplay, {
                  key: _ctx.farmerAcc,
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  farmer: _ctx.farmer,
                  farmerAcc: _ctx.farmerAcc,
                  class: "mb-10",
                  onRefreshFarmer: _ctx.handleRefreshFarmer
                }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
                _createVNode(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT
                }, {
                  default: _withCtx(() => [
                    (_ctx.farmerState === 'staked' && _ctx.selectedNFTs.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "rounded bg-dark py-2 px-4 mr-5",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addGems && _ctx.addGems(...args)))
                        }, " Move Residents "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'unstaked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "rounded bg-dark py-2 px-4 mr-5",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                        }, " Begin staking "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'staked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "rounded bg-dark py-2 px-4 mr-5",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End staking "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'pendingCooldown')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "rounded bg-dark py-2 px-4 mr-5",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End cooldown "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "rounded bg-dark py-2 px-4",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                    }, " Claim " + _toDisplayString(_ctx.availableA / 1000000000) + " $SHILLS ", 1)
                  ]),
                  _: 1
                }, 8, ["vault", "onSelectedWalletNft"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "rounded bg-dark py-2 px-4",
                    style: {"margin-top":"25px","margin-bottom":"1.75rem"},
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, " Setup ")
                ])
              ]))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({ information: !_ctx.wallet, info: _ctx.wallet })
    }, _hoisted_26, 2)
  ]))
}